module.exports = __webpack_public_path__ + "static/media/PoultryFarmSolutionsblue.787d7175.svg";